
export enum ChangeRequestTypeEnum {
    EnglishName = 1,
    ChinesName = 2,
    ContactNumber  = 3,
    EmailAddress = 4,
    ResidentialAddress = 5,
    MailingAddress = 6,
    Nationality = 7,
    BankAccountDetails = 8,
    CountryOfTaxResidence = 9,
    SourceOfFund = 10,
    EmploymentDetails = 11,
    CompanyName = 12
}


export enum ChangeRequestStatus {
    Submitted = 1,
    WaitingForAdminApproval = 2,
    Approved = 3,
    Rejected = 4
}
